/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { useOktaAuth } from '@okta/okta-react';
import { LoadingSpinner, BallCapSessionDisplay as NYYBallcapSessionDisplay } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import { Ballcap, useOktaQueries, HeatMaps, Stats } from '../../data';

const BallcapSessionDisplay = ({ playerId, sessionId, sessionDate }) => {
    const { t: translate } = useTranslation();
    const { authState } = useOktaAuth();

    const yearid = (new Date(sessionDate)).getFullYear();

    const queries = [
        { queryKey: ['ballcap-session', playerId, sessionId], queryFn: (token) => Ballcap.getSession(token, playerId, sessionId) },
        { queryKey: ['heatmaps-2', playerId], queryFn: (token) => HeatMaps.getPitcherHeatMaps(token, playerId, 2) },
        { queryKey: ['pitches', playerId, yearid], queryFn: (token) => Stats.pitches(token, playerId, yearid) },
    ];

    const queryResults = useOktaQueries(queries);
    const isLoading = queryResults.some((q) => q.isLoading || q.isFetching);

    if (isLoading) {
        return (
            <>
                <LoadingSpinner />
            </>
        );
    }

    const session = queryResults[0].data;
    const heatmaps = queryResults[1].data;
    const allPitcherPitches = queryResults[2].data;

    const breakplotsCallback = async (pt) => {
        const results = await Stats.breakplots(authState.accessToken, playerId, pt);
        const mappedResults = results.map((r) => ({ ...r, HeatMapImg: r.Base64Data }));
        return mappedResults;
    };
    const percentilesCallback = async (pt) => Stats.percentiles(authState.accessToken, { pitchType: pt, levelid: 8, yearid });

    if (!isLoading && (!session?.Session || !session?.Videos || session?.Videos?.length === 0)) {
        return (
            <>
                <h5>{translate('sections.ballcap.session-not-found')}</h5>
            </>
        );
    }

    return (
        <NYYBallcapSessionDisplay
            data={session}
            sessionId={sessionId}
            allPitcherPitches={allPitcherPitches}
            percentiles={percentilesCallback}
            breakplots={breakplotsCallback}
            heatmaps={heatmaps}
        />
    );
};

BallcapSessionDisplay.propTypes = {
    playerId: PropTypes.number.isRequired,
    sessionId: PropTypes.number.isRequired,
    sessionDate: PropTypes.string.isRequired,
};

export default BallcapSessionDisplay;
